import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { ItemStatusIndicatorComponent } from './item-status-indicator/item-status-indicator.component';
import { A48StatusIndicatorComponent } from './act48/a48-status-indicator.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HistoryItemComponent } from './history-item/history-item.component';
import { VerificationActionIndicatorComponent } from './verification-status-indicator/verification-action-indicator.component';
import { UserCycleHistoryItemComponent } from './user-cycle-history-item/user-cycle-history-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LaddaModule } from 'angular2-ladda';
import { EdllNotesComponent } from './edl-notes/edl-notes.component';
import { PipesModule } from '../pipes/pipes.module';
import { EdlCommonPipesModule } from '@edl-development/edl-common';
import { ItemSubTypeInfoComponent } from './item-sub-type-info/item-sub-type-info.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        LaddaModule,
        EdlCommonPipesModule,
        PipesModule
    ],
    declarations: [
        HistoryItemComponent,
        UserCycleHistoryItemComponent,
        ItemStatusIndicatorComponent,
        A48StatusIndicatorComponent,
        VerificationActionIndicatorComponent,
        EdllNotesComponent,
        ItemSubTypeInfoComponent
    ],
    exports: [
        HistoryItemComponent,
        UserCycleHistoryItemComponent,
        ItemStatusIndicatorComponent,
        A48StatusIndicatorComponent,
        EdllNotesComponent,
        VerificationActionIndicatorComponent,
        ItemSubTypeInfoComponent
    ]
})
export class ComponentModule { }